import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, Provider } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AlertModule } from 'ngx-bootstrap';
import { SharedModule } from './shared/shared.module';

import { environment } from '../environments/environment';

import { AuthService, AuthMonitoriasModule, SessionProgramMonitoriaService, EncryptionInterceptor, EncryptionModule, RSA_PUBLIC_KEY, RSA_KEY_PROD } from 'auth-monitorias-uniandes';
import { LocatorService } from './locator.service';
import { LoginService } from './login.service';

import { AppComponent } from './app.component';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';

let productionProviders: Provider[] = [];

if (environment.executionEnvironment === "production") {
  productionProviders.push(
    { provide: RSA_PUBLIC_KEY, useValue: RSA_KEY_PROD },
    { provide: HTTP_INTERCEPTORS, useClass: EncryptionInterceptor, multi: true }
  );
}

const routes: Routes = [
  { path: 'login.html', component: LoginComponent, pathMatch: 'full' },
  { path: 'logout.html', component: LogoutComponent, pathMatch: 'full' },
  { path: 'forbidden.html', component: ForbiddenComponent, pathMatch: 'full' }
];

@NgModule({
  declarations: [
    AppComponent,
    ForbiddenComponent,
    LoginComponent,
    LogoutComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AuthMonitoriasModule.forRoot({
      production: environment.production,
      appUrlApi: environment.localhostUrl,
      user: environment.user,
      pwd: environment.pwd
    }),
    RouterModule.forRoot(routes),
    AlertModule.forRoot(),
    SharedModule,
    EncryptionModule
  ],
  providers: [
    SessionProgramMonitoriaService, 
    AuthService, 
    LoginService, 
    LocatorService,

    ...productionProviders

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts